import React from "react";

const teamMembers = [
  {
    name: "Sreeram Kumar",
    role: "Founder & CEO",
    img: "https://randomuser.me/api/portraits/men/32.jpg",
    linkedin: "#",
    instagram: "#",
  },
  {
    name: "Anjali Nair",
    role: "Marketing Head",
    img: "https://randomuser.me/api/portraits/women/45.jpg",
    linkedin: "#",
    instagram: "#",
  },
  {
    name: "Rahul Menon",
    role: "Product Manager",
    img: "https://randomuser.me/api/portraits/men/68.jpg",
    linkedin: "#",
    instagram: "#",
  },
];

const About = () => {
  return (
    <main className="min-h-screen bg-gray-50 py-12 px-6">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center">
        
        {/* Left Side - Image */}
        <div>
          <img
            src="https://res.cloudinary.com/dri1qrcuu/image/upload/v1753957738/about_ojf5rm.jpg"
            alt="About GlowAura"
            className="rounded-xl shadow-lg"
          />
        </div>

        {/* Right Side - Content */}
        <div>
          <h1 className="text-4xl font-bold text-rose-700 mb-4">About GlowAura</h1>
          <p className="text-gray-700 mb-4">
            Welcome to <strong>GlowAura</strong>, your trusted destination for 
            premium beauty and skincare products. Our mission is to bring you 
            high-quality, safe, and effective products that enhance your natural glow.
          </p>

          <p className="text-gray-700 mb-4">
            At GlowAura, we carefully curate our collection to ensure 
            that every product meets our strict standards of quality and 
            authenticity. We believe that skincare should be simple, 
            effective, and luxurious.
          </p>

          <p className="text-gray-700 mb-6">
            Our team is passionate about helping you look and feel your best 
            every day. Thank you for trusting us with your beauty journey!
          </p>

          <div className="space-y-2">
            <p>📍 <strong>Location:</strong> Kochi, Kerala</p>
            <p>📞 <strong>Phone:</strong> +91 98765 43210</p>
            <p>📧 <strong>Email:</strong> support@glowaura.com</p>
          </div>
        </div>
      </div>

      {/* Our Values Section */}
      <div className="max-w-6xl mx-auto mt-16 text-center">
        <h2 className="text-3xl font-semibold text-rose-700 mb-6">✨ Our Values</h2>
        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-white p-6 rounded-xl shadow-md">
            <h3 className="text-xl font-bold text-rose-600 mb-2">Quality</h3>
            <p className="text-gray-600">We source only premium, tested, and safe products for our customers.</p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-md">
            <h3 className="text-xl font-bold text-rose-600 mb-2">Trust</h3>
            <p className="text-gray-600">Your satisfaction and trust are our top priorities in every purchase.</p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-md">
            <h3 className="text-xl font-bold text-rose-600 mb-2">Care</h3>
            <p className="text-gray-600">We are committed to providing personalized support for all your needs.</p>
          </div>
        </div>
      </div>

      {/* Team Section */}
      <div className="max-w-6xl mx-auto mt-20 text-center">
        <h2 className="text-3xl font-semibold text-rose-700 mb-10">👩‍💼 Meet Our Team</h2>
        <div className="grid md:grid-cols-3 gap-10">
          {teamMembers.map((member, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition"
            >
              <img
                src={member.img}
                alt={member.name}
                className="w-32 h-32 mx-auto rounded-full object-cover mb-4"
              />
              <h3 className="text-xl font-bold text-gray-800">{member.name}</h3>
              <p className="text-gray-500">{member.role}</p>

              <div className="flex justify-center space-x-4 mt-3">
                <a
                  href={member.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:underline"
                >
                  LinkedIn
                </a>
                <a
                  href={member.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-pink-500 hover:underline"
                >
                  Instagram
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
};

export default About;
